import { render, staticRenderFns } from "./DeviceCamera.vue?vue&type=template&id=685ce5a7&scoped=true&"
import script from "./DeviceCamera.vue?vue&type=script&lang=js&"
export * from "./DeviceCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685ce5a7",
  null
  
)

export default component.exports